import { AdViewType } from '@ad-lucy/utils/types/enums';

// Breakpoint Display Names (for grid definitions)
export const BREAKPOINT_DISPLAY_NAME = {
  SITEBAR: 'Sitebar',
  HPA: 'HPA',
  MOBILE: 'Mobile',
} as const;

// Breakpoint Values (using AdViewType enum values)
export const BREAKPOINT_VALUE = {
  SITEBAR: AdViewType.SITEBAR,
  HPA: AdViewType.HPA,
  MOBILE: AdViewType.MOBILE,
  BILLBOARD: AdViewType.BILLBOARD,
} as const;
